import { walk } from './Pointer';
import { getFriendlyDifferenceMessage, isEqual } from './compare';
export var OperationType;
(function (OperationType) {
    OperationType["ADD"] = "add";
    OperationType["REMOVE"] = "remove";
    OperationType["REPLACE"] = "replace";
    OperationType["TEST"] = "test";
})(OperationType || (OperationType = {}));
function add(pointerTarget, value) {
    let index = parseInt(pointerTarget.segment, 10);
    if (Array.isArray(pointerTarget.target) && !isNaN(index)) {
        pointerTarget.target.splice(index, 0, value);
    }
    else {
        pointerTarget.target[pointerTarget.segment] = value;
    }
    return pointerTarget.object;
}
function replace(pointerTarget, value) {
    let index = parseInt(pointerTarget.segment, 10);
    if (Array.isArray(pointerTarget.target) && !isNaN(index)) {
        pointerTarget.target.splice(index, 1, value);
    }
    else {
        pointerTarget.target[pointerTarget.segment] = value;
    }
    return pointerTarget.object;
}
function remove(pointerTarget) {
    if (Array.isArray(pointerTarget.target)) {
        pointerTarget.target.splice(parseInt(pointerTarget.segment, 10), 1);
    }
    else {
        delete pointerTarget.target[pointerTarget.segment];
    }
    return pointerTarget.object;
}
function inverse(operation, state) {
    if (operation.op === OperationType.ADD) {
        const op = {
            op: OperationType.REMOVE,
            path: operation.path
        };
        const test = {
            op: OperationType.TEST,
            path: operation.path,
            value: operation.value
        };
        return [test, op];
    }
    else if (operation.op === OperationType.REPLACE) {
        const value = operation.path.get(state);
        let op;
        if (value === undefined) {
            op = {
                op: OperationType.REMOVE,
                path: operation.path
            };
        }
        else {
            op = {
                op: OperationType.REPLACE,
                path: operation.path,
                value: operation.path.get(state)
            };
        }
        const test = {
            op: OperationType.TEST,
            path: operation.path,
            value: operation.value
        };
        return [test, op];
    }
    else {
        return [
            {
                op: OperationType.ADD,
                path: operation.path,
                value: operation.path.get(state)
            }
        ];
    }
}
export class Patch {
    constructor(operations) {
        this._operations = Array.isArray(operations) ? operations : [operations];
    }
    apply(object) {
        let undoOperations = [];
        const patchedObject = this._operations.reduce((patchedObject, next) => {
            let object;
            const pointerTarget = walk(next.path.segments, patchedObject);
            switch (next.op) {
                case OperationType.ADD:
                    object = add(pointerTarget, next.value);
                    break;
                case OperationType.REPLACE:
                    object = replace(pointerTarget, next.value);
                    break;
                case OperationType.REMOVE:
                    object = remove(pointerTarget);
                    break;
                case OperationType.TEST:
                    const current = pointerTarget.target[pointerTarget.segment];
                    if (!isEqual(current, next.value)) {
                        const location = next.path.path;
                        throw new Error(`Test operation failure at "${location}". ${getFriendlyDifferenceMessage(next.value, current)}.`);
                    }
                    return patchedObject;
                default:
                    throw new Error('Unknown operation');
            }
            undoOperations = [...inverse(next, patchedObject), ...undoOperations];
            return object;
        }, object);
        return { object: patchedObject, undoOperations };
    }
}
//# sourceMappingURL=Patch.mjs.map